// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination","Pagination__pageSize":"Pagination__pageSize","MuiSelect-select":"MuiSelect-select"};